
/// Require

var ModalActionButton = require('./modal-action-button');
var BaseModal = require('./base-modal');


/// Config

var endpoint     = '/admin/ajax/vouchers/redeem';
var errorClass   = 'error';
var successClass = 'positive';
var failureClass = 'negative';


//
// Void Modal
//

module.exports = function VoidModal ($host, config) {

  var base = BaseModal($host, config);


  // Dom

  var $inputName    = $('[name="void-name"]',        $host);
  var $inputReason  = $('[name="void-reason"]',      $host);
  var $outputName   = $('[data-modal-output-name]',  $host);
  var $outputCode   = $('[data-modal-output-code]',  $host);


  // Widgets

  var actionButton = getWidgetAtDom($('[data-action="void"]', $host));


  /// State

  var state = {
    vid:    null,
    name:   null,
    code:   null,
    user:   null,
    reason: null
  };


  /// Functions

  function populate (data) {

    if (!isdef(data.voucher_id)) console.warn("RedeemModal::populate - expected key 'voucher_code' but didn't find it.");
    if (!isdef(data.code))       console.warn("RedeemModal::populate - expected key 'code' but didn't find it.");
    if (!isdef(data.voucher_title))       console.warn("RedeemModal::populate - key 'name' not supplied - it will be blank.");

    // Reset input and output values
    $inputName.val(null);
    $inputReason.val(null);
    $outputName.text(data.voucher_title ? data.voucher_title : "");
    $outputCode.text(data.code);

    // Copy new code into state
    state.code = data.code;
    state.vid  = data.voucher_id;

    // Clear visual state
    $host.removeClass(successClass);
    actionButton.setMode(ModalActionButton.ACTION_NEUTRAL);

    // Wait slightly for modal to be visible, then focus first input
    delay(0.2, $inputName.focus.bind($inputName));
  }

  function checkCompleteness () {
    state.name   = $inputName.val();
    state.reason = $inputReason.val();
    actionButton.setMode((!!state.name && !!state.reason) ? ModalActionButton.ACTION_READY : ModalActionButton.ACTION_NEUTRAL);
  }


  /// Listeners

  $inputName.on('change keyup',   checkCompleteness);
  $inputReason.on('change keyup', checkCompleteness);

  actionButton.onCancelClick(base.conceal);

  actionButton.onReadyClick(function () {
    actionButton.submit({
      vid: state.vid,
      void_name: state.name,
      void_reason: state.reason
    });
  });

  actionButton.onSuccess(function () {
    $host.addClass(successClass);
    delay(1, base.conceal);
    delay(1.1, reloadPage);
  });


  /// Interface

  return {
    invoke: function (data) {
      base.reveal();
      populate(data);
    }
  }

};

